import { gql } from "graphql-tag"

const typeObligations = gql`
  type Obligation {
    customerNumber: String
    sumOpenOrders: Float
    obligoWa: Float
    obligoWe: Float
    total: Float
  }

  type Query {
    customerObligation(
      customerNumber: String!
      page: Int = 0
      size: Int = 5
      sort: Sort = { orderBy: "obligoDate", direction: "desc" }
    ): Obligation
  }
`

export { typeObligations }
export default typeObligations
